<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CDataTable
            outlined
            hover
            striped
            tableFilter
            columnFilter
            sorter
            :sorter-value="{ column: 'name', asc: false }"
            :fields="sectionBuilderEditorsUiMeta"
            :items="sectionBuilderEditors"
            :items-per-page="20"
            clickable-rows
            :active-page="activePage"
            :pagination="{ align: 'center'}"
            @page-change="pageChange"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #section_builders="{item}">
              <td>
                <button
                  v-for="sectionBuilder in item.section_builders"
                  :key="sectionBuilder.id"
                  type="button" 
                  class="btn btn-outline-dark"
                  style="margin-left: 5px;"
                  @click="$router.push({ path: `section-builder-editor/${sectionBuilder.id}`})"
                >{{sectionBuilder.name}}
                </button>
              </td>
            </template>
          </CDataTable>
          <div style="text-align: center; color: #4f5d73">{{i18nMessage.TotalRows}}: {{sectionBuilderEditors.length}}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'

export default {
  name: 'SectionBuilderEditors',
  data () {
    return {
      activePage: 1,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      sectionBuilderEditors: state => state.pageBuilder.sectionBuilderEditors,
      sectionBuilderEditorsUiMeta: state => state.pageBuilder.sectionBuilderEditorsUiMeta,
    }),
  },
  methods: {
    ...mapActions({
      listSectionBuilderEditors: 'pageBuilder/listSectionBuilderEditors',
    }),
    ...mapMutations({
      setSectionBuilderEditors: 'pageBuilder/setSectionBuilderEditors',
    }),
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    },
  },
  created () {
  },
  mounted () {
    this.listSectionBuilderEditors()
  },
  destroyed () {
    this.setSectionBuilderEditors([])
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
}
</script>